<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="页面计划"
      :innerHeight="500"
      width="810px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- SPU维度切片计划 -->
      <div class="spu-item">
        <div class="spu-item-header">
          <el-row :gutter="10">
            <el-col :span="12">SPU编码：{{spuCode}}</el-col>
            <el-col :span="12">SPU名称：{{spuInfo.spuName || '-'}}</el-col>
          </el-row>
        </div>
        <div class="spu-item-form">
          <el-form :model="spuForm" :inline="true"  size="small">
            <el-tag type="warning" size="mini" class="form-tag">切片</el-tag>
            <el-form-item label="计划结束：">
              <el-date-picker
                v-model="spuForm.planEndTime"
                :picker-options="pickerOptions"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="计划人员：">
              <el-select 
                  v-model="spuForm.planPersonId"
                  filterable=""
                  placeholder="请选择"
                  >
                  <el-option
                    v-for="item in userList"
                    :key="item.userId"
                    :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                    :value="item.userId">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="tips">提示：SPU的切片计划必须要完整填写，才能够继续。<span>如有遗漏则无法进入下一步！</span></div>
    </q-dialog>
  </div>
</template>

<script>
import {newProductStepEnum} from '@/utils/constant'
import axios from "@/utils/axiosInstance";
import moment from 'moment'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'spuCode', 'isJumpDesign'],
  data() {
    const ONE_DAY_MILLSECONDS = 24 * 60 * 60 * 1000;
    return {
      dialogVisible: false,
      loading: false,
      spuInfo: {},
      spuForm: {
        planEndTime: '',
        planPersonId: '',
        taskId: newProductStepEnum.sectioning
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < (Date.now() - ONE_DAY_MILLSECONDS);
        }
      },
      userList: []
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
    this.getSpuInfo();
    this.getUserList()
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    checkValid() {
      const {planEndTime, planPersonId} = this.spuForm;
      if (!!planEndTime && planPersonId) {
        return true;
      }
      this.$message.error('请将SPU的切片计划填写完整。');
      return false;
    },
    confirm() {
      if (!this.checkValid()) {
        return false;
      }
      const params = [{
        ...this.spuForm,
        spuId: this.spuInfo.dataId,
        spuCode: this.spuCode,
        planEndTime: this.spuForm.planEndTime ? moment(this.spuForm.planEndTime).format('YYYY-MM-DD') : '',
        planPerson: this.spuForm.planPersonId ? this.userList.find(v=>v.userId == this.spuForm.planPersonId).userName : "",
      }];
      this.$q.newProduct.savePlan({data: params})
        .then(({success}) => {
          if (success) {
            this.$notify.success({
              title: '成功',
              message: '保存页面计划成功',
            });
            this.updateVal();
            this.$emit('success');
          }
        });
    },
    getSpuInfo() {
      const params = {
        data: {
          pageNum: 1,
          pageSize: 1,
          filterData: {
            spuCode: this.spuCode
          }
        }
      };
      this.loading = true;
      return this.$q.newProduct.listPage(params)
        .then(({data}) => {
          this.spuInfo = data && data.records && data.records[0] || {};
        })
        .catch(console.log)
        .finally(() => {
          this.loading = false;
        });
    },
    getUserList() {
      let data = {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "getUserInfoByName",
      }
      this.$q.newProduct.getUserInfoByName({data})
        .then((res) => {
          if (res.code == 200) {
            console.log(res.data);
            this.userList = res.data.list;
          }
        });
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-dialog__content
    overflow-x hidden
  .spu-item
    margin-bottom 10px
  .spu-item-header
    margin-bottom 15px
    >>> .el-col
      line-height 24px
      font-weight bold
  .spu-item-form
    >>> .el-form-item
      margin-bottom 10px

  .slidex-enter
    transform translateX(100px)
    opacity 0
  .slidex-enter-active,.slidex-leave-active
    transition all linear .3s
    opacity 1
    position absolute
    >>> .el-button
      display inline-block
  .slidex-leave-to
    transform translateX(-100px)
    opacity 0
  
  .form-tag
    position relative
    top 6px

  .tips
    font-size 14px
    margin-top 10px
    color #999
    span
      color #E63946
</style>